import { tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { smartDocStaticParamType_Attribute } from './types.js';
import { Validator_SmartDocParmaResolver_VariableResolver } from '../../../smart-doc-param-resolver/index.js';
import { Validator_SmartDocStaticParamType } from '../_base/index.js';
export const Validator_SmartDocStaticParam_Attribute = {
    key: tsValidateString(),
    type: Validator_SmartDocStaticParamType,
    subType: tsValidateValue([smartDocStaticParamType_Attribute]),
    resolver: Validator_SmartDocParmaResolver_VariableResolver,
    parentKey: tsValidateString(),
    id: tsValidateUniqueId,
};
//# sourceMappingURL=validator.js.map